<template>
<crud-layout :title="title" :subtitle="subtitle" :add-button="true" @add="create">

        <template v-slot:list>
            <company-list 
                       ref="list"
                       @update="update"
                       @delete="remove"
                       @show="show"
            
            />
        </template>
      
        <company-create v-if="creating" 
                        :open="creating"
                        v-on:itemCreated="onItemCreated" 
                        v-on:close="creating=false" 
        />
        
        <company-update v-if="updating" 
                        :open="updating"
                        :item="itemToEdit" 
                        v-on:itemUpdated="onItemUpdated" 
                        v-on:close="updating=false" 
        />
          
        <company-show v-if="showing" 
                           :open="showing" 
                           :item="itemToShow"  
                           v-on:close="showing=false" 
         />

        <!-- <company-delete v-if="deleting" 
                         :open="deleting"
                         :item="itemToDelete"  
                         v-on:itemDeleted="onItemDeleted" 
                         v-on:close="deleting=false" 
        /> -->

        <snackbar v-model="flash"/>

</crud-layout>
</template>

<script>
    
    import CompanyCreate from "../CompanyCreate";
    import CompanyUpdate from "../CompanyUpdate";
    // import CompanyDelete from "../CompanyDelete";
    import CompanyShow from "../CompanyShow";
    import CompanyList from "../CompanyList";
    import CompanyProvider from "../../../providers/CompanyProvider";
    
     import {CrudLayout, Snackbar} from "@dracul/common-frontend"
     
    export default {
        name: "CompanyCrud",
        components: {
            CrudLayout, Snackbar,
            CompanyCreate, 
            CompanyUpdate, 
            // CompanyDelete, 
            CompanyShow,
            CompanyList
        },
        data() {
            return {
                title: 'admin.company.title',
                subtitle: 'admin.company.subtitle',
                flash: null,
                creating: false,
                updating: false,
                deleting: false,
                showing: false,
                itemToEdit: null,
                itemToDelete: null,
                itemToShow: null,
            }
        },
        methods: {
            //On
            onItemCreated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.created")
            },
            onItemUpdated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.updated")
            },
            onItemDeleted() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.deleted")
            },
            //Open
            create() {
                this.creating = true
            },
            async update(item) {
                // Hacer fetch completo del item para obtener todos los campos AFIP
                try {
                    const response = await CompanyProvider.findCompany(item.id);
                    this.itemToEdit = response.data.companyFind;
                    this.updating = true;
                } catch (error) {
                    console.error('Error obteniendo datos completos de la empresa:', error);
                    // Si falla, usar el item de la lista como fallback
                    this.itemToEdit = item;
                    this.updating = true;
                }
            },
            show(item) {
                this.showing = true
                this.itemToShow = item
            },
            remove(item) {
                this.deleting = true
                this.itemToDelete = item
            }
        }
        
    }
</script>

